import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import RegisterParent from '../../RegisterParent';

/**
 * Invite New Parent as a child of the New Appointment modal.
 * Cancel / Esc / success close via onClose (RegisterParent onCancel) —
 * outer New Appointment stays open.
 */
const InviteNewParentModal = ({ isOpen, onClose, invitePhone = '' }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <Modal
      isOpen
      size="lg"
      className="model-form invite-new-parent-modal"
      toggle={onClose}
      backdrop="static"
      keyboard={false}
      autoFocus={false}
    >
      <ModalHeader className="header-form">Invite New Parent</ModalHeader>
      <ModalBody>
        <RegisterParent onCancel={onClose} invitePhone={invitePhone} />
      </ModalBody>
    </Modal>
  );
};

export default InviteNewParentModal;
